module.exports = {
  "providers": {
    "mode": "append",
    "redirectOnSingle": false,
    "entries": []
  },
  "loginMethod": "dual",
  "api": {},
  "project": {}
}



//////////////////
// WEBPACK FOOTER
// ./config/@sanity/default-login.json?sanityPart=config%3A%40sanity%2Fdefault-login
// module id = 487
// module chunks = 0